import { useState } from 'react'

export const useDropdown = () => {
  const [openDropdown, setOpenDropdown] = useState<boolean>(false)

  const toggleDropdown = () => {
    setOpenDropdown((prev) => !prev)
  }

  const closeDropdown = () => {
    setOpenDropdown(false)
  }

  return {
    isDropdownOpen: openDropdown,
    toggleDropdown,
    closeDropdown
  }
}
